<template>
  <div class="list-widget">

    <div
      class="list-widget__header"
      v-if="!hideHeader"
    >
      <span>
        <button
          type="button"
          v-if="canToggle"
          v-bind:class="{ 'list-widget__toggle': true, 'icon': true, 'icon--rows': toggled, 'icon--boxes': !toggled }"
          v-on:click="toggle"
        ></button>
        <h1><slot name="header"></slot></h1>
        &nbsp;&nbsp;<span class="orange" v-if="!routeName==='lastEditeds'">{{ totalCount }}</span>
      </span>
      <span><slot name="add-button"></slot></span>
    </div>

    <div class="list-widget__content items-container">
      <template v-if="addNewRouteName !== 'false'">
        <slot name="item-template" :item="{ isNewRoute: true, name: addNewTitle }">
          <router-link class="items-container__item item add-new-item"
          :to="{ name: addNewRouteName }"
          >
            <div class="item__row item__title">
              <slot name="item-template-title">
                <span>{{ addNewTitle }}</span>
              </slot>
            </div>
          </router-link>
        </slot>
    </template>
    <template v-for="(item, key) in items">
      <slot name="item-template" :item="item">
        <widgetItem
          :key="key"
          :item="item"
          :routeName="routeName"
          :toggled="toggled"
          :isWebsocketConnect="isWebsocketConnect"
        />
      </slot>
    </template>

    </div>
    <div
      v-if="!hideFooter"
      class="list-widget__footer items-container__footer"
    >
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import 'styles/blocks/list-widget.scss';
import widgetItem from './widgetItem.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'list-widget',
  components: {
    widgetItem
  },
  computed: {
    routeAcceptsMobileScreen() {
      return typeof this.$route.meta.onMobileScreen === 'object';
    },
    ...mapGetters({
      isMobileScreen: 'screen/isMobileScreen',
    }),
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    totalCount: {
      type: Number,
      required: false,
    },
    routeName: {
      type: String,
      required: true,
    },
    hideHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
    canToggle: {
      type: Boolean,
      required: false,
      default: false,
    },
    changeRoute: {
      type: Boolean,
      required: false,
      default: false,
    },
    addNewRouteName: {
      type: String,
      required: false,
      default: 'false',
    },
    addNewTitle: {
      type: String,
      required: false,
      default: '',
    },
    doNotRouteOnRouteNames: {
      type: Array,
      required: false,
      default: () => [],
    },
    isWebsocketConnect: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      toggled: false,
    };
  },
  watch: {
    items: 'changeToRoute',
    $route: 'changeToRoute',
    isMobileScreen: 'changeToRoute',
  },
  methods: {
    toggle() {
      this.toggled = !this.toggled;
    },
    changeToRoute() {
      if (this.$route.name === this.addNewRouteName
        || this.doNotRouteOnRouteNames.includes(this.$route.name)
        || this.isMobileScreen
        || this.$route.params.id) {
        return;
      }
      if (this.changeRoute && this.items.length > 0
        && !this.$route.params.id
        && !(this.isMobileScreen && this.routeAcceptsMobileScreen)) {
        this.$router.push({ name: this.routeName, params: { id: this.items[0].id } });
      } else if (this.changeRoute && this.items.length === 0) {
        this.$router.push({ name: `${this.routeName}s` });
      }
    },
  },
};
</script>

<style lang="scss">
  .item__title--icon span {
    display: flex;
    align-items: center;
  }
  .type-icon {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-size: contain;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ListWidget.vue